const constants = {
  ACTIONS: {
    GLOBAL_SEARCH_REQUEST: "GLOBAL_SEARCH_REQUEST",
    SET_SEARCH_RESULTS: "SET_SEARCH_RESULTS",
    CLEAR_SEARCH_RESULTS: "CLEAR_SEARCH_RESULTS"
  } as { [key: string]: SearchStore.eActionType },
};

export default constants;
